import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updatePatientNote = async (noteID, editedContent) => {
  const apiURL = API_HOST + '/patient_notes/' + noteID;
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.put(
      apiURL,
      {
        patient_note: {
          content: editedContent,
          note_id: noteID,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
